export function ClockIcon() {
  return (
    <svg
      id="graphic"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      class="animate-clock-spin"
    >
      <path
        fill="currentColor"
        d="M11,11.77h-.17v-.38c0-1.66-1.02-3.25-2.83-4.43.38-.25.72-.51,1.03-.79,1.18-1.07,1.8-2.33,1.8-3.64v-.3h.17c.3,0,.54-.24.54-.54s-.24-.54-.54-.54H3c-.3,0-.54.24-.54.54s.24.54.54.54h.14v.3c0,1.66,1.02,3.25,2.83,4.43-.38.25-.72.51-1.03.79-1.18,1.07-1.8,2.33-1.8,3.64v.38h-.14c-.3,0-.54.24-.54.54s.24.54.54.54h8c.3,0,.54-.24.54-.54s-.24-.54-.54-.54ZM4.3,2.53v-.3h5.37v.3c0,1.03-.5,2.03-1.46,2.9-.35.33-.76.62-1.23.89-1.71-1-2.69-2.37-2.68-3.79ZM4.21,11.52c0-1.06.52-2.09,1.51-2.99.18-.17.38-.33.59-.49,0,0,0,0,.01,0,.21-.15.42-.29.65-.42.88.52,1.57,1.13,2.05,1.79.47.67.72,1.38.72,2.12v.26h-5.54v-.26Z"
      />
    </svg>
  )
}
